import PropTypes from 'prop-types'
import { Outlet, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './common/components/ProtectedRoute.jsx'
import { rutasProtegidas, rutasPublicas } from './common/config/routes.config.jsx'
import NotFound from './pages/not-found/Index.jsx'

function Layout({ embedded }) {
  return (
    <div className={embedded ? 'w-full' : 'mx-[40px] mt-[20px] lg:mx-[96px]'}>
      <Outlet />
    </div>
  )
}

export default function ApplicationRoutes({ embedded = false, sessionUuid, onSessionExpired }) {
  return (
    <Routes>
      <Route element={<Layout embedded={embedded} />}>
        {rutasPublicas.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
      <Route
        element={
          <ProtectedRoute sessionUuid={sessionUuid} onSessionExpired={onSessionExpired} embedded={embedded}>
            <Layout embedded={embedded} />
          </ProtectedRoute>
        }
      >
        {rutasProtegidas.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

Layout.propTypes = { embedded: PropTypes.bool.isRequired }
ApplicationRoutes.propTypes = {
  embedded: PropTypes.bool,
  sessionUuid: PropTypes.string,
  onSessionExpired: PropTypes.func,
}
